// Shared normalized mouse position for the 3D scene (decoupled from canvas events).
export const pointer = {
  x: 0, // -1 .. 1
  y: 0, // -1 .. 1
  targetX: 0,
  targetY: 0,
};

let initialized = false;

export function initPointerTracking() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  window.addEventListener(
    "pointermove",
    (e) => {
      pointer.targetX = (e.clientX / window.innerWidth) * 2 - 1;
      pointer.targetY = -((e.clientY / window.innerHeight) * 2 - 1);
    },
    { passive: true },
  );
}

export function isTouchDevice() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia("(hover: none), (pointer: coarse)").matches
  );
}
